import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

export const resetProgressModalOpenAtomFamily = atomFamily(
  (_teamMemberId: string) => atom(false),
);
